import React from "react";
import {
    Box, Typography, Chip, Avatar, ListItemButton,
} from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import moment from "moment";

const MODE_CHIP = {
    bot: { label: "Bot", color: "#1565c0", bg: "#e3f2fd", icon: <SmartToyOutlinedIcon sx={{ fontSize: 12 }} /> },
    human: { label: "Humano", color: "#2e7d32", bg: "#e8f5e9", icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 12 }} /> },
};

const STATUS_DOT = {
    open: "#4caf50",
    closed: "#bdbdbd",
};

export default function ConversationListItem({ conversation, selected, onClick }) {
    const { contact, mode, status, last_message, last_inbound_at, lead_data } = conversation;

    const name = contact?.name || contact?.phone || contact?.wa_id || "Desconocido";
    const initials = name.slice(0, 2).toUpperCase();
    const modeConfig = MODE_CHIP[mode] || MODE_CHIP.bot;
    const isAiFlow = lead_data?.sales_flow;

    const preview = last_message?.body || "";
    // Fecha = última vez que el CONTACTO escribió (last_inbound_at), no el último
    // mensaje: así los mensajes automáticos del bot / envíos masivos no falsean
    // la recencia. El preview del texto sí sigue siendo el último mensaje. La que abrimos
    // con una plantilla y todavía no responde muestra cuándo le escribimos.
    const since = last_inbound_at || conversation.last_outbound_at;
    const timeAgo = since ? moment(since).fromNow() : "";

    return (
        <ListItemButton
            onClick={() => onClick(conversation)}
            selected={selected}
            sx={{
                px: 1.5,
                py: 1,
                borderBottom: "1px solid #f0f0f0",
                "&.Mui-selected": { bgcolor: "#ede7f6" },
                "&:hover": { bgcolor: "#fafafa" },
            }}
        >
            {/* Avatar */}
            <Avatar
                sx={{
                    width: 40, height: 40, mr: 1.5,
                    bgcolor: isAiFlow ? "#7b1fa2" : "#1565c0",
                    fontSize: 14, fontWeight: 700,
                    flexShrink: 0,
                }}
            >
                {initials}
            </Avatar>

            <Box sx={{ flex: 1, overflow: "hidden" }}>
                {/* Nombre + tiempo */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: 13 }} noWrap>
                        {name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#999", fontSize: 10, flexShrink: 0, ml: 1 }}>
                        {timeAgo}
                    </Typography>
                </Box>

                {/* Preview del último mensaje */}
                <Typography
                    variant="body2"
                    sx={{ color: "#666", fontSize: 12, mt: 0.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                    {preview || "Sin mensajes"}
                </Typography>

                {/* Chips: modo + status + AI */}
                <Box sx={{ display: "flex", gap: 0.5, mt: 0.5, flexWrap: "wrap" }}>
                    <Box
                        sx={{
                            display: "inline-flex", alignItems: "center", gap: 0.3,
                            bgcolor: modeConfig.bg, color: modeConfig.color,
                            borderRadius: 10, px: 0.8, py: 0.1, fontSize: 10, fontWeight: 600,
                        }}
                    >
                        {modeConfig.icon}
                        {modeConfig.label}
                    </Box>

                    {/* Punto de status */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
                        <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: STATUS_DOT[status] || "#bdbdbd" }} />
                        <Typography sx={{ fontSize: 10, color: "#888" }}>{status}</Typography>
                    </Box>

                    {/* Badge AI si tiene sales_flow */}
                    {isAiFlow && (
                        <Box sx={{
                            display: "inline-flex", alignItems: "center", gap: 0.3,
                            bgcolor: "#ede7f6", color: "#7b1fa2",
                            borderRadius: 10, px: 0.8, py: 0.1, fontSize: 10, fontWeight: 600,
                        }}>
                            <AutoAwesomeOutlinedIcon sx={{ fontSize: 11 }} />
                            IA
                        </Box>
                    )}

                    {/* Lead score si existe */}
                    {lead_data?.last_ai_score != null && (
                        <Typography sx={{ fontSize: 10, color: "#999", alignSelf: "center" }}>
                            score: {(lead_data.last_ai_score * 100).toFixed(0)}%
                        </Typography>
                    )}
                </Box>
            </Box>
        </ListItemButton>
    );
}
